'use client';

import MuiBox from '@new-components/atoms/MuiBox';
import MuiButton from '@new-components/atoms/MuiButton';
import MuiTypography from '@new-components/atoms/MuiTypography';
import {DownloadIcon} from './DownloadIcon';
import {useLeadForm} from '@new-components/templates/LeadGeneration/provider';
import {trackMouseClicks} from '@utils/googleAnalytics/googleAnalyticsEvents';

interface DownloadBrochureProps {
  text: string;
  description: string;
  brochureLink: string;
  communityId: string;
  communityName: string;
  brandType: string;
}

const DownloadBrochure: React.FC<DownloadBrochureProps> = ({
  text,
  description,
  ...props
}) => {
  const {show} = useLeadForm();
  const handleBrouchureClick = () => {
    show({
      formType:
        props.brandType === 'lsq' ? 'LSQ_BROCHURE_FORM' : 'BROCHURE_FORM',
      brochureLink: props.brochureLink,
      communityName: props.communityName,
      id: props.communityId,
    });
    trackMouseClicks({type: 'button', label: 'view_brochure'});
  };
  return (
    <MuiBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '250px',
      }}>
      <MuiTypography
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          color: 'rgba(0, 50, 67, 1)',
          opacity: 0.3,
          marginBottom: '8px',
          wordWrap: 'break-word',
        }}>
        {description}
      </MuiTypography>
      <MuiButton
        onClick={handleBrouchureClick}
        variant='outlined'
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '10px 16px',
          borderRadius: '24px',
          borderColor: 'rgba(0, 50, 67, 1)',
          color: 'rgba(0, 50, 67, 1)',
          width: '100%',
          maxWidth: '250px',
        }}>
        <MuiBox sx={{minWidth: '16px', minHeight: '16px'}}>
          <DownloadIcon />
        </MuiBox>
        {text}
      </MuiButton>
    </MuiBox>
  );
};

export default DownloadBrochure;
